import React, { useEffect, useState } from "react";
import "./tools.css";
import InputBase from "@mui/material/InputBase";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import Dropdown from "react-bootstrap/Dropdown";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import Switch from "@mui/material/Switch";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from 'react-redux';
import DepartmentOtp from "../../pages/Auth/Login/DepartmentOtp";
import Tooltip from '@mui/material/Tooltip';
import { DepartmentDistrictBadge } from './DepartmentIdentityCell';
import {
  userLogout,
  fetchHoldingAccountConfiguration,
  updateHoldingAccountConfiguration,
} from '../../helper/Api'
import {
  SET_EXPENSE_DATE_BASIS,
  DEFAULT_EXPENSE_DATE_BASIS,
} from '../../RTK/Slices/AppConfigSlice';
import { persistor } from '../../RTK/Store/Index';

const HOLDING_CONFIG_FIELDS = [
  { key: 'tds_it', label: 'TDS IT' },
  { key: 'cgst', label: 'CGST' },
  { key: 'sgst', label: 'SGST' },
  { key: 'igst', label: 'IGST' },
  { key: 'other_deduction', label: 'Other Deduction' },
  { key: 'royalty', label: 'Royalty' },
  { key: 'labour', label: 'Labour' },
  { key: 'penalty', label: 'Penalty' },
  { key: 'withheld', label: 'Withheld' },
];

const EXPENSE_DATE_OPTIONS = [
  { value: 'voucher_order_date', label: 'Voucher / Order Date' },
  // Payment Date hidden until BE stores payment_date
  // { value: 'payment_date', label: 'Payment Date' },
  { value: 'ppa_date', label: 'PPA Date' },
];

const getGoogleTranslateSelect = () =>
  document.querySelector("#google_translate_element select.goog-te-combo") ||
  document.querySelector("select.goog-te-combo");

const dispatchTranslateChange = (select) => {
  select.dispatchEvent(new Event("change", { bubbles: true }));
};

const clearGoogTransCookie = () => {
  const past = "Thu, 01 Jan 1970 00:00:00 UTC";
  const { hostname } = window.location;

  document.cookie = `googtrans=;expires=${past};path=/`;
  document.cookie = `googtrans=;expires=${past};path=/;domain=${hostname}`;

  const parts = hostname.split(".");
  if (parts.length > 1) {
    document.cookie = `googtrans=;expires=${past};path=/;domain=.${parts.slice(-2).join(".")}`;
  }
};

const getActiveTranslateLanguage = () => {
  const match = document.cookie.match(/googtrans=\/en\/([^;]+)/);
  return match?.[1] || "en";
};

const isPageTranslated = () =>
  document.documentElement.classList.contains("translated-ltr") ||
  document.documentElement.classList.contains("translated-rtl");

const resetGoogleTranslateToEnglish = (select) => {
  clearGoogTransCookie();

  let targetIndex = 0;
  for (let i = 0; i < select.options.length; i += 1) {
    const option = select.options[i];
    if (option.value === "" || option.value === "en") {
      targetIndex = i;
      break;
    }
  }

  select.selectedIndex = targetIndex;
  dispatchTranslateChange(select);

  setTimeout(() => {
    select.selectedIndex = targetIndex;
    dispatchTranslateChange(select);

    if (isPageTranslated()) {
      window.location.reload();
    }
  }, 200);
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Tools = ({ toggleButton }) => {
  const dispatch = useDispatch();
  const {authData, financialYears} = useSelector((state) => state.authData);
  const expenseDateBasis = useSelector(
    (state) => state.appConfig?.expenseDateBasis || DEFAULT_EXPENSE_DATE_BASIS
  );
  const [data, setData] = useState(null);
  const [departmentName, setDepartmentName] = useState(null);
  const [userName, setUserName] = useState(null);
  const [hamberger, setHamberger] = useState(true);
  const [dropdownValue, setDropdownValue] = useState("Username");
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [openGlobalConfig, setOpenGlobalConfig] = useState(false);
  const [holdingConfigData, setHoldingConfigData] = useState(null);
  const [holdingConfigDraft, setHoldingConfigDraft] = useState(null);
  const [isEditingHoldingConfig, setIsEditingHoldingConfig] = useState(false);
  const [holdingConfigLoading, setHoldingConfigLoading] = useState(false);
  const [expenseDateBasisDraft, setExpenseDateBasisDraft] = useState(DEFAULT_EXPENSE_DATE_BASIS);
  const [isEditingExpenseConfig, setIsEditingExpenseConfig] = useState(false);
  const [expandedConfigPanel, setExpandedConfigPanel] = useState('holding');
  const [departmentId, setDepartmentId] = useState(null);
  const [userType, setUserType] = useState(null);
  const [userLevel, setUserLevel] = useState(null);
  const [languageAnchorEl, setLanguageAnchorEl] = useState(null);
  const [selectedLanguage, setSelectedLanguage] = useState(() => getActiveTranslateLanguage());
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetchHoldingAccountConfig = async () => {
    try {
      setHoldingConfigLoading(true);
      const response = await fetchHoldingAccountConfiguration();
      if (response?.data?.status) {
        setHoldingConfigData(response.data.data);
      } else {
        toast.error(response?.data?.message || 'Failed to fetch holding account configuration', {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to fetch holding account configuration', {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setHoldingConfigLoading(false);
    }
  };

  const handleOpenGlobalConfig = async () => {
    setOpenGlobalConfig(true);
    setExpandedConfigPanel('holding');
    setExpenseDateBasisDraft(expenseDateBasis);
    setIsEditingExpenseConfig(false);
    await fetchHoldingAccountConfig();
  };

  const handleCloseGlobalConfig = () => {
    setOpenGlobalConfig(false);
    setHoldingConfigData(null);
    setHoldingConfigDraft(null);
    setIsEditingHoldingConfig(false);
    setExpenseDateBasisDraft(expenseDateBasis);
    setIsEditingExpenseConfig(false);
    setExpandedConfigPanel('holding');
  };

  const canUpdateHoldingConfig =
    String(authData?.user?.user_type || '').toLowerCase() === 'l3' &&
    String(authData?.user?.department_details?.department_level || '').toUpperCase() === 'T1';

  const handleStartHoldingConfigEdit = () => {
    setHoldingConfigDraft({ ...holdingConfigData });
    setIsEditingHoldingConfig(true);
  };

  const handleCancelHoldingConfigEdit = () => {
    setHoldingConfigDraft(null);
    setIsEditingHoldingConfig(false);
  };

  const handleToggleHoldingConfig = (key) => {
    setHoldingConfigDraft((prev) => ({
      ...prev,
      [key]: String(prev?.[key]) === '1' ? 0 : 1,
    }));
  };

  const handleSaveHoldingConfig = async () => {
    const payload = HOLDING_CONFIG_FIELDS.reduce((changes, { key }) => {
      if (Number(holdingConfigData?.[key]) !== Number(holdingConfigDraft?.[key])) {
        changes[key] = Number(holdingConfigDraft[key]);
      }
      return changes;
    }, {});

    if (!Object.keys(payload).length) {
      setIsEditingHoldingConfig(false);
      setHoldingConfigDraft(null);
      return;
    }

    try {
      setHoldingConfigLoading(true);
      const response = await updateHoldingAccountConfiguration(payload);
      if (response?.data?.status) {
        setHoldingConfigData(response.data.data);
        setIsEditingHoldingConfig(false);
        setHoldingConfigDraft(null);
        toast.success(response?.data?.message || 'Holding account configuration updated successfully', {
          position: toast.POSITION.TOP_CENTER,
        });
      } else {
        toast.error(response?.data?.message || 'Failed to update configuration', {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to update configuration', {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      setHoldingConfigLoading(false);
    }
  };

  const handleStartExpenseConfigEdit = () => {
    setExpenseDateBasisDraft(expenseDateBasis);
    setIsEditingExpenseConfig(true);
  };

  const handleCancelExpenseConfigEdit = () => {
    setExpenseDateBasisDraft(expenseDateBasis);
    setIsEditingExpenseConfig(false);
  };

  const handleSaveExpenseConfig = async () => {
    if (expenseDateBasisDraft === expenseDateBasis) {
      setIsEditingExpenseConfig(false);
      return;
    }

    dispatch(SET_EXPENSE_DATE_BASIS(expenseDateBasisDraft));
    setIsEditingExpenseConfig(false);
    setOpenGlobalConfig(false);
    await persistor.flush();
    window.location.reload();
  };

  const activeHoldingConfig = isEditingHoldingConfig ? holdingConfigDraft : holdingConfigData;

  const renderConfigStatus = (value) => {
    const isEnabled = String(value) === '1';
    return (
      <span
        style={{
          display: 'inline-block',
          padding: '4px 10px',
          borderRadius: '999px',
          fontSize: '12px',
          fontWeight: 600,
          backgroundColor: isEnabled ? '#d4edda' : '#f1f3f5',
          color: isEnabled ? '#155724' : '#6c757d',
        }}
      >
        {isEnabled ? 'Yes' : 'No'}
      </span>
    );
  };

  useEffect(() => {
    const storedData = JSON.parse(sessionStorage.getItem("userDetails"));
    setData(storedData);
    setDepartmentName(authData?.user.department_details.name);
    setUserName(storedData.user.user_name);
    setDepartmentId(storedData?.user?.department_details?.id);
    setUserType(storedData?.user?.user_type);
    setUserLevel(storedData?.user?.user_type);
    // console.log(storedData)
  }, [authData]);
  useEffect(() => {
    const initGoogleTranslate = () => {
      const container = document.getElementById("google_translate_element");
      if (!container || container.querySelector(".goog-te-combo") || !window.google?.translate?.TranslateElement) {
        return;
      }

      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          includedLanguages: "en,hi",
          autoDisplay: false,
        },
        "google_translate_element"
      );
    };

    window.googleTranslateElementInit = initGoogleTranslate;

    const existingScript = document.getElementById("google-translate-script");
    if (existingScript) {
      if (window.google?.translate?.TranslateElement) {
        initGoogleTranslate();
      }
    } else {
      const script = document.createElement("script");
      script.id = "google-translate-script";
      script.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      delete window.googleTranslateElementInit;
    };
  }, []);

  useEffect(() => {
    const hideGoogleTranslateBar = () => {
      document.querySelectorAll("iframe.goog-te-banner-frame, .goog-te-banner-frame").forEach((el) => {
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
        el.style.setProperty("height", "0", "important");
      });
      document.body.style.setProperty("top", "0", "important");
      document.body.style.setProperty("position", "static", "important");
    };

    hideGoogleTranslateBar();
    const observer = new MutationObserver(hideGoogleTranslateBar);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["style", "class"],
    });

    return () => observer.disconnect();
  }, []);
  /*useEffect(() => {
        // Check if the SpeechSynthesis API is available
        if ('speechSynthesis' in window) {
            const synthesis = window.speechSynthesis;
            const voices = synthesis.getVoices();

            // Example function to speak a given text
            const speakText = (text) => {
                const utterance = new SpeechSynthesisUtterance(text);
                utterance.voice = voices[0]; // Use the first available voice
                synthesis.speak(utterance);
            };

            // Example usage
            const handleTextToSpeechClick = () => {
                const textToSpeak = 'Hello, this is a sample text for text-to-speech.';
                speakText(textToSpeak);
            };

            // Attach the event listener to the text-to-speech icon
            const textToSpeechIconElement = document.getElementById('text_to_speech_icon');
            if (textToSpeechIconElement) {
                textToSpeechIconElement.addEventListener('click', handleTextToSpeechClick);
            }
        }
    }, []);*/

  // const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLanguageClick = (event) => {
    setLanguageAnchorEl(event.currentTarget);
  };

  const handleLanguageClose = () => {
    setLanguageAnchorEl(null);
  };

  const triggerGoogleTranslate = (lang, retries = 10) => {
    const select = getGoogleTranslateSelect();
    if (!select) {
      if (retries > 0) {
        setTimeout(() => triggerGoogleTranslate(lang, retries - 1), 300);
      }
      return;
    }

    if (lang === "en") {
      if (!isPageTranslated() && getActiveTranslateLanguage() === "en") {
        setSelectedLanguage("en");
        handleLanguageClose();
        return;
      }

      resetGoogleTranslateToEnglish(select);
      setSelectedLanguage("en");
      handleLanguageClose();
      return;
    }

    for (let i = 0; i < select.options.length; i += 1) {
      if (select.options[i].value === lang) {
        select.selectedIndex = i;
        dispatchTranslateChange(select);
        break;
      }
    }

    setSelectedLanguage(lang);
    handleLanguageClose();
  };

  const handleLanguageSelect = (lang) => {
    triggerGoogleTranslate(lang);
  };
  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  const handleDropdownSelect = (eventKey) => {
    setDropdownValue(eventKey);
  };

  const handleLogout = async () => {
    // Clear all session storage
    await userLogout();
    sessionStorage.clear();
    localStorage.clear()
    // toast.success("Logged out successfully!");
  };

  const navigate = useNavigate();
  const otp = "007";

  const addElipsis = (str, limit, elip = "...") => {
    return str && str.length > limit
      ? str.substring(0, limit) + `${elip}`
      : str;
  };

  return (
    <>
      <nav className="h-60px d-flex justify-content-between align-items-center bg-secondary-100 px-2 poppins-regular">
        <div className="d-flex gap-3 align-items-center ">
          <div className={`${hamberger ? null : "rotate"} transition`}>
            {toggleButton}
          </div>

          {/* <span
            style={{ border: "2px solid #ebebeb" }}
            className="p-1 rounded-3 d-flex justify-content-center align-items-center"
          >
            <SearchIcon className="text-white"/>
            <InputBase
              sx={{ ml: 1, flex: 1 }}
              className="text-white "
              placeholder="search scheme"
            />
          </span> */}

          <div className="fw-medium text-white pb-1">
            SNA - Financial Management System
          </div>
        </div>

        <div className="d-flex gap-2 align-items-center">
          <span className="fw-medium text-white d-inline-flex align-items-center gap-2">
            {departmentName}
            <DepartmentDistrictBadge row={authData?.user?.department_details} />
          </span>

          {
            authData.user.user_type === 'l3' && <i className="icon-assignment cursor-pointer fs-5 transition text-white submenu-hover-collpase p-2 rounded-2 submenu-active" onClick={() => navigate("/user-activity")}></i>
          }

          <Tooltip title="Language" arrow>
            <i
              className="icon-g_translate cursor-pointer fs-5 transition text-white submenu-hover-collpase p-2 rounded-2 submenu-active"
              onClick={handleLanguageClick}
            ></i>
          </Tooltip>

          <Menu
            anchorEl={languageAnchorEl}
            open={Boolean(languageAnchorEl)}
            onClose={handleLanguageClose}
            TransitionComponent={Fade}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem
              selected={selectedLanguage === "en"}
              onClick={() => handleLanguageSelect("en")}
            >
              English
            </MenuItem>
            <MenuItem
              selected={selectedLanguage === "hi"}
              onClick={() => handleLanguageSelect("hi")}
            >
              Hindi
            </MenuItem>
          </Menu>

          <Tooltip title="Global App Configuration" arrow>
            <i
              className="icon-settings cursor-pointer fs-5 transition text-white submenu-hover-collpase p-2 rounded-2 submenu-active"
              onClick={handleOpenGlobalConfig}
            ></i>
          </Tooltip>

          <div className="position-relative d-inline-block">
            <i
              className="icon-notifications_none cursor-pointer transition icons-hover fs-5 p-2 rounded-2 text-white submenu-hover-collpase submenu-active"
              onClick={handleClick}
            ></i>

            <span
              className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
              style={{
                fontSize: "0.65rem",
                transform: "translate(-50%, 50%)",
              }}
            >
              0
            </span>
          </div>

          <i
            className="icon-shuffle cursor-pointer fs-5 transition text-white submenu-hover-collpase p-2 rounded-2 submenu-active"
            onClick={handleClickOpen}
          ></i>

          <div className="d-flex align-items-center gap-8px">
            <Dropdown onSelect={handleDropdownSelect}>
              <Dropdown.Toggle
                id="dropdown-basic"
                className="text-white py-1 px-2 d-flex align-items-center gap-3 bg-transparent"
                style={{ border: "1px solid #fff" }}
              >
                  <Tooltip title={userName} arrow>
                    <div className="d-flex flex-column">
                      <p className="fs-14px m-0 p-0">{addElipsis(userName, 11)}</p>
                      <span className="m-0 p-0 fw-500 fs-10px text-start">
                        {userLevel}
                      </span>
                    </div>
                  </Tooltip>
              </Dropdown.Toggle>
            </Dropdown>
            <i
              className="icon-power_settings_new fs-4 transition submenu-hover-collpase submenu-active text-white p-2 rounded-2 cursor-pointer"
              onClick={() => {
                handleLogout();
                navigate("/login");
              }}
            ></i>
          </div>
        </div>
        <Dialog
          open={openGlobalConfig}
          onClose={handleCloseGlobalConfig}
          maxWidth="sm"
          fullWidth
          PaperProps={{ sx: { borderRadius: '8px' } }}
        >
          <DialogTitle
            sx={{
              color: '#28326f',
              fontWeight: 600,
              fontSize: '18px',
              pb: 1,
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
              <span style={{ lineHeight: 1.3 }}>Global App Configuration</span>
              <IconButton
                aria-label="close"
                onClick={handleCloseGlobalConfig}
                size="small"
                sx={{ color: '#28326f', flexShrink: 0 }}
              >
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent dividers sx={{ p: 0 }}>
            {holdingConfigLoading && !holdingConfigData ? (
              <DialogContentText sx={{ p: 2 }}>Loading configuration...</DialogContentText>
            ) : (
              <Box>
                <Accordion
                  disableGutters
                  elevation={0}
                  expanded={expandedConfigPanel === 'holding'}
                  onChange={(_, isExpanded) => setExpandedConfigPanel(isExpanded ? 'holding' : false)}
                  sx={{
                    '&:before': { display: 'none' },
                    borderBottom: '1px solid #e9ecef',
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: '#28326f' }} />}
                    sx={{ px: 2, minHeight: 52, '& .MuiAccordionSummary-content': { my: 1, alignItems: 'center', gap: 1.5 } }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', width: '100%', pr: 1 }}>
                      <span style={{ color: '#28326f', fontWeight: 600, fontSize: '15px' }}>
                        Holding Account Configuration
                      </span>
                      {canUpdateHoldingConfig && !holdingConfigLoading && (
                        isEditingHoldingConfig ? (
                          <>
                            <Button
                              size="small"
                              className="navigation_button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleCancelHoldingConfigEdit();
                              }}
                              sx={{ py: '4px !important', px: '10px !important', fontSize: '12px !important', minWidth: 'auto' }}
                            >
                              Cancel
                            </Button>
                            <Button
                              size="small"
                              className="submit_button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSaveHoldingConfig();
                              }}
                              sx={{ py: '4px !important', px: '10px !important', fontSize: '12px !important', minWidth: 'auto' }}
                            >
                              Save
                            </Button>
                          </>
                        ) : (
                          <Button
                            size="small"
                            className="navigation_button"
                            onClick={(e) => {
                              e.stopPropagation();
                              setExpandedConfigPanel('holding');
                              handleStartHoldingConfigEdit();
                            }}
                            sx={{ py: '4px !important', px: '10px !important', fontSize: '12px !important', minWidth: 'auto' }}
                          >
                            Update
                          </Button>
                        )
                      )}
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    {holdingConfigLoading ? (
                      <DialogContentText sx={{ p: 2 }}>Loading holding configuration...</DialogContentText>
                    ) : (
                      HOLDING_CONFIG_FIELDS.map((field, index) => (
                        <div
                          key={field.key}
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            padding: '12px 16px',
                            borderBottom: index === HOLDING_CONFIG_FIELDS.length - 1 ? 'none' : '1px solid #e9ecef',
                            backgroundColor: index % 2 === 0 ? '#fff' : '#f8f9fc',
                          }}
                        >
                          <span style={{ color: '#28326f', fontWeight: 500, fontSize: '14px' }}>
                            {field.label}
                          </span>
                          {isEditingHoldingConfig ? (
                            <Switch
                              size="small"
                              checked={String(activeHoldingConfig?.[field.key]) === '1'}
                              onChange={() => handleToggleHoldingConfig(field.key)}
                              color="primary"
                            />
                          ) : (
                            renderConfigStatus(activeHoldingConfig?.[field.key])
                          )}
                        </div>
                      ))
                    )}
                  </AccordionDetails>
                </Accordion>

                <Accordion
                  disableGutters
                  elevation={0}
                  expanded={expandedConfigPanel === 'expense'}
                  onChange={(_, isExpanded) => setExpandedConfigPanel(isExpanded ? 'expense' : false)}
                  sx={{ '&:before': { display: 'none' } }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: '#28326f' }} />}
                    sx={{ px: 2, minHeight: 52, '& .MuiAccordionSummary-content': { my: 1, alignItems: 'center', gap: 1.5 } }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', width: '100%', pr: 1 }}>
                      <span style={{ color: '#28326f', fontWeight: 600, fontSize: '15px' }}>
                        Expense Configuration
                      </span>
                      {isEditingExpenseConfig ? (
                          <>
                            <Button
                              size="small"
                              className="navigation_button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleCancelExpenseConfigEdit();
                              }}
                              sx={{ py: '4px !important', px: '10px !important', fontSize: '12px !important', minWidth: 'auto' }}
                            >
                              Cancel
                            </Button>
                            <Button
                              size="small"
                              className="submit_button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleSaveExpenseConfig();
                              }}
                              sx={{ py: '4px !important', px: '10px !important', fontSize: '12px !important', minWidth: 'auto' }}
                            >
                              Save
                            </Button>
                          </>
                        ) : (
                          <Button
                            size="small"
                            className="navigation_button"
                            onClick={(e) => {
                              e.stopPropagation();
                              setExpandedConfigPanel('expense');
                              handleStartExpenseConfigEdit();
                            }}
                            sx={{ py: '4px !important', px: '10px !important', fontSize: '12px !important', minWidth: 'auto' }}
                          >
                            Update
                          </Button>
                        )}
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails sx={{ px: 2, py: 1.5 }}>
                    {isEditingExpenseConfig ? (
                      <FormControl component="fieldset">
                        <RadioGroup
                          value={expenseDateBasisDraft}
                          onChange={(e) => setExpenseDateBasisDraft(e.target.value)}
                        >
                          {EXPENSE_DATE_OPTIONS.map((option) => (
                            <FormControlLabel
                              key={option.value}
                              value={option.value}
                              control={<Radio size="small" />}
                              label={
                                <span style={{ color: '#28326f', fontWeight: 500, fontSize: '14px' }}>
                                  {option.label}
                                </span>
                              }
                              sx={{
                                mx: 0,
                                mb: 0.5,
                                px: 1,
                                py: 0.5,
                                borderRadius: '6px',
                                backgroundColor:
                                  expenseDateBasisDraft === option.value ? '#f0f4ff' : 'transparent',
                              }}
                            />
                          ))}
                        </RadioGroup>
                      </FormControl>
                    ) : (
                      <div>
                        {EXPENSE_DATE_OPTIONS.map((option, index) => (
                          <div
                            key={option.value}
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              padding: '10px 8px',
                              borderBottom:
                                index === EXPENSE_DATE_OPTIONS.length - 1 ? 'none' : '1px solid #e9ecef',
                            }}
                          >
                            <span style={{ color: '#28326f', fontWeight: 500, fontSize: '14px' }}>
                              {option.label}
                            </span>
                            <span
                              style={{
                                display: 'inline-block',
                                padding: '4px 10px',
                                borderRadius: '999px',
                                fontSize: '12px',
                                fontWeight: 600,
                                color: '#fff',
                                backgroundColor:
                                  expenseDateBasis === option.value ? '#198754' : '#adb5bd',
                              }}
                            >
                              {expenseDateBasis === option.value ? 'Selected' : '—'}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                  </AccordionDetails>
                </Accordion>
              </Box>
            )}
          </DialogContent>
        </Dialog>

        <Dialog
          open={open}
          TransitionComponent={Transition}
          keepMounted
          onClose={handleClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DepartmentOtp
            switchFormClose={handleClose}
            open={open}
            colFull={true}
            departmentId={departmentId}
            otp={otp}
            userType={userType}
          />
        </Dialog>
      </nav>

      <div className="google-translate-widget-hidden notranslate" aria-hidden="true">
        <div id="google_translate_element" />
      </div>
    </>
  );
};

export default Tools;
